import { Box, Button, Typography } from "@mui/material";
import iconRight from "../../assets/iconRight.png";
import { useNavigate } from "react-router-dom";

const SignInPage = () => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(180deg, #211540 0%, #5636A6 100%)",
        textAlign: "center",
        padding: 4,
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: "#ffffff",
          font: "Times New Roman, serif",
          fontSize: "3rem",
          fontWeight: 600,
          letterSpacing: 1,
          marginBottom: 2,
        }}
      >
        Welcome to RevOptica
      </Typography>

      <Typography
        variant="h6"
        sx={{
          font: "Times New Roman, serif",
          fontSize: "1.4rem",
          color: "#C8C8C8",
          marginBottom: 6,
        }}
      >
        Buyer Journey Visualization & Analytics for B2B Startups
      </Typography>
      <Box sx={{ mt: 16 }}>
        <Button
          variant="contained"
          size="large"
          onClick={handleSignUp}
          sx={{
            backgroundColor: "#2A7BFF",
            color: "#fff",
            paddingX: 2,
            paddingY: 1.5,
            fontWeight: 600,
            textTransform: "none",
            fontSize: "1rem",
            "&:hover": {
              backgroundColor: "#1D63E8",
            },
          }}
        >
          Let's Get Started
          <img
            src={iconRight}
            alt="icon right"
            style={{ opacity: 1, marginLeft: 10 }}
          />
        </Button>
      </Box>
    </Box>
  );
};

export default SignInPage;
